import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PulseAiSummaryComponent } from './pulse-ai-summary.component';
import { ButtonModule, TooltipModule } from '@xref/xref-lib';

@NgModule({
  declarations: [PulseAiSummaryComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TooltipModule
  ],
  exports: [PulseAiSummaryComponent]
})
export class PulseAiSummaryModule {}
